import { travel } from "../data/site";
import useTransitionTo from "../utils/useTransitionTo";

const TravelTeaser = () => {
  const t = travel;
  const transitionTo = useTransitionTo();

  return (
    <section
      className="section-bleed"
      id="travel"
      style={{ "--travel-img": `url(${t.image})` } as React.CSSProperties}
    >
      <div className="travel-overlay" />
      <div className="travel-content">
        <div className="travel-eyebrow">
          <span className="sec-num light">04</span>
          <span className="sec-kicker">{t.kicker}</span>
        </div>
        <h2 className="travel-h2">{t.headline}</h2>
        <p className="travel-lead">{t.lead}</p>
        <a
          className="travel-cta"
          href="/travel"
          onClick={(e) => { e.preventDefault(); transitionTo("/travel"); }}
        >
          Read the travel journal →
        </a>
      </div>
    </section>
  );
};

export default TravelTeaser;
